<section class="upsell-card" [attr.aria-label]="product.name?.[lang]">
  @if (bands.length) {
    <div class="upsell-badges">
      @for (band of bands; track $index) {
        <span class="upsell-badge" [style.background]="band.background" [style.color]="band.color">
          {{ band.text?.[lang] }}
        </span>
      }
    </div>
  }

  <div class="upsell-header">
    <div class="upsell-icon" aria-hidden="true">
      <mat-icon>group</mat-icon>
    </div>
    <div class="upsell-titles">
      @if (product.hasTopLabel && product.topLabel?.[lang]) {
        <div class="upsell-headline">{{ product.topLabel[lang] }}</div>
      }
      <h3 class="upsell-name">{{ product.name?.[lang] }}</h3>
    </div>
    <ng-content select="[upsellHelp]"></ng-content>
  </div>

  @if (product.description?.[lang]) {
    <div class="upsell-description" [innerHTML]="product.description[lang]"></div>
  }

  @if (fullDescriptionText) {
    <div class="upsell-description" [innerHTML]="fullDescriptionText"></div>
  }

  @if (benefits.length) {
    <ul class="upsell-benefits">
      @for (benefit of benefits; track $index) {
        <li>
          <span class="upsell-benefit-icon" aria-hidden="true"><mat-icon>check</mat-icon></span>
          <span [innerHTML]="benefit"></span>
        </li>
      }
    </ul>
  }

  <div class="upsell-footer">
    <div class="upsell-price">
      <span class="upsell-price-label">{{ 'COMMON.UPSELL_CARD.ONE_TIME_FEE' | translate }}</span>
      <span class="upsell-price-values">
        @if (product.showOldPrice && product.oldPrice) {
          <span class="upsell-price-old">
            {{ (product.oldPrice / 100).toFixed(2) }} {{ 'COMMON.UPSELL_CARD.PL_CURRENCY' | translate }}
          </span>
        }
        <span class="upsell-price-amount">
          {{ (product.basePrice / 100).toFixed(2) }} {{ 'COMMON.UPSELL_CARD.PL_CURRENCY' | translate }}
        </span>
      </span>
    </div>
    <div class="upsell-cta">
      <ng-content select="[upsellCta]"></ng-content>
    </div>
  </div>

  <ng-content></ng-content>
</section>
